<ng-template #creditPreview let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">RMA# {{orderdetails.header.orderno}}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body" *ngIf="orderdetails">

		<!-- Header: addresses + order meta -->
		<div class="row mb-3">
			<div class="col-md-4">
				<small class="text-muted text-uppercase font-weight-bold">Bill To</small>
				<div [innerHTML]="orderdetails.header.billto"></div>
			</div>
			<div class="col-md-4">
				<small class="text-muted text-uppercase font-weight-bold">Pickup / Ship To</small>
				<div [innerHTML]="orderdetails.header.shipto"></div>
			</div>
			<div class="col-md-4">
				<small class="text-muted text-uppercase font-weight-bold">Credit Info</small>
				<table class="table table-sm table-borderless mb-0">
					<tbody>
						<tr *ngIf="orderdetails.header.from_order">
							<td class="p-0 text-muted">Source Invoice#</td>
							<td class="p-0">{{orderdetails.header.from_order}}</td>
						</tr>
						<tr *ngIf="orderdetails.header.customerref">
							<td class="p-0 text-muted">PO#</td>
							<td class="p-0">{{orderdetails.header.customerref}}</td>
						</tr>
						<tr *ngIf="orderdetails.header.freightcost > 0">
							<td class="p-0 text-muted">Freight</td>
							<td class="p-0">{{orderdetails.header.freightcost | currency}}</td>
						</tr>
						<tr *ngIf="orderdetails.header.shippername">
							<td class="p-0 text-muted">Ship Via</td>
							<td class="p-0">{{orderdetails.header.shippername}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<ng-container *ngIf="orderdetails.header.notes || orderdetails.header.comments">
			<div class="row mb-2">
				<div class="col-md-6" *ngIf="orderdetails.header.notes">
					<small class="text-muted text-uppercase font-weight-bold">Notes</small>
					<div>{{orderdetails.header.notes}}</div>
				</div>
				<div class="col-md-6" *ngIf="orderdetails.header.comments">
					<small class="text-muted text-uppercase font-weight-bold">Dispatch Note</small>
					<div>{{orderdetails.header.comments}}</div>
				</div>
			</div>
		</ng-container>

		<hr class="mt-1 mb-2">

		<!-- Line items -->
		<div class="table-responsive">
			<table class="table table-sm">
				<thead>
					<tr>
						<th>ITEM</th>
						<th>DESC</th>
						<th class="text-center">ORDERED</th>
						<th class="text-center">INVOICED</th>
						<th class="text-center">OUTSTANDING</th>
						<th class="text-right">PRICE</th>
						<th class="text-right">DISCOUNT</th>
						<th class="text-right">TOTAL</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let item of orderdetails.details">
						<td>{{item.stkcode}}</td>
						<td>{{item.description}}</td>
						<td class="text-center">{{item.ordered}}</td>
						<td class="text-center">{{item.qtyinvoiced}}</td>
						<td class="text-center">{{item.ordered - item.qtyinvoiced}}</td>
						<td class="text-right">{{item.unitprice | currency}}</td>
						<td class="text-right">{{item.discountpercent | percent}}</td>
						<td class="text-right">{{item.discountprice * item.ordered | currency}}</td>
					</tr>
				</tbody>
				<tfoot>
					<tr *ngFor="let t of orderdetails.saved_totals">
						<td colspan="6"></td>
						<td class="text-right font-weight-bold">{{t.title}}:</td>
						<td class="text-right">{{t.text | currency}}</td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<div class="main-content">
	<div class="container-fluid">
		<div class="card rma-log">
			<div class="card-header card-header-{{color}}-1">
				<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> RMA Log</h4>
				<p class="card-category">RMAs by status and who entered them.</p>
			</div>
			<div class="card-body">

				<!-- Filters -->
				<div class="rma-filters">
					<mat-form-field appearance="outline" class="f-dates">
						<mat-label>RMA Dates</mat-label>
						<mat-date-range-input [rangePicker]="picker" (keyup.enter)="loadRmas();">
							<input matStartDate [formControl]="fromdateCtrl" placeholder="Start date">
							<input matEndDate [formControl]="todateCtrl" placeholder="End date">
						</mat-date-range-input>
						<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-date-range-picker #picker></mat-date-range-picker>
					</mat-form-field>

					<mat-form-field appearance="outline" class="f-enteredby">
						<mat-label>Entered By</mat-label>
						<input matInput [formControl]="enteredbyCtrl" placeholder="e.g. APALDINO" (keyup.enter)="loadRmas();">
					</mat-form-field>

					<mat-form-field appearance="outline" class="f-status">
						<mat-label>Status</mat-label>
						<mat-select [formControl]="stateCtrl" (selectionChange)="loadRmas()">
							<mat-option *ngFor="let s of state_filters" [value]="s.value">{{ s.name }}</mat-option>
						</mat-select>
					</mat-form-field>

					<mat-form-field appearance="outline" class="f-search">
						<mat-label>Search (customer / RMA# / credit#)</mat-label>
						<input matInput [formControl]="keywords" (keyup.enter)="loadRmas();">
					</mat-form-field>

					<button class="btn btn-primary rma-load" (click)="loadRmas()" [disabled]="sending">
						<i class="material-icons">search</i> Load
					</button>
				</div>

				<!-- Summary + export -->
				<div class="rma-toolbar">
					<div class="rma-chips">
						<span class="results">{{ rmas.length }} result{{ rmas.length === 1 ? '' : 's' }}</span>
						<button type="button" class="chip chip--all"       [class.active]="stateCtrl.value==='all'"       (click)="quickState('all')">All</button>
						<button type="button" class="chip chip--processed" [class.active]="stateCtrl.value==='processed'" (click)="quickState('processed')">Processed {{ countState('processed') }}</button>
						<button type="button" class="chip chip--open"      [class.active]="stateCtrl.value==='open'"      (click)="quickState('open')">Open {{ countState('open') }}</button>
						<button type="button" class="chip chip--received"  [class.active]="stateCtrl.value==='received'"  (click)="quickState('received')">Ready To Credit {{ countState('received') }}</button>
						<button type="button" class="chip chip--partial"   [class.active]="stateCtrl.value==='partial'"   (click)="quickState('partial')">Partially Received {{ countState('partial') }}</button>
						<button type="button" class="chip chip--review"    [class.active]="stateCtrl.value==='review'"    (click)="quickState('review')">Needs Reconciling {{ countState('review') }}</button>
						<button type="button" class="chip chip--cancelled" [class.active]="stateCtrl.value==='cancelled'" (click)="quickState('cancelled')">Cancelled {{ countState('cancelled') }}</button>
					</div>
					<div class="rma-export">
						<button class="btn-export pdf" (click)="pdf()" [disabled]="!rmas.length" title="Export PDF"><i class="fa fa-file-pdf-o"></i></button>
						<button class="btn-export xls" (click)="excel()" [disabled]="!rmas.length" title="Export Excel"><i class="fa fa-file-excel-o"></i></button>
					</div>
				</div>

				<!-- Table -->
				<div class="rma-table-wrap" #print_basic>
					<table class="rma-table">
						<thead>
							<tr>
								<th *ngFor="let c of columns"
									[class.right]="c.align==='right'"
									[class.center]="c.align==='center'"
									[class.sorted]="sortField===c.key"
									(click)="setSort(c.key)">
									{{ c.label }}
									<span class="sort-ind">{{ sortField===c.key ? (sortAsc ? '▲' : '▼') : '' }}</span>
								</th>
								<th class="center">Received</th>
								<th class="center"></th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let r of rmas">
							<tr [class.row--exceptions]="reviewReasons(r).length">
								<td class="mono">{{ r.rma_no }}</td>
								<td class="nowrap">{{ r.date_created | date:'MM/dd/yyyy' }}</td>
								<td class="cust"><span class="cust-id">{{ r.debtorno }}</span> {{ r.customer }}</td>
								<td class="mono">{{ r.enteredby | uppercase }}</td>
								<td><span class="pill" [ngClass]="pillClass(r.rma_state)">{{ r.rma_state }}</span></td>
								<td class="mono">{{ r.credit_no ? r.credit_no : '—' }}</td>
								<td class="right amount" [class.neg]="r.credit_total < 0">{{ r.credit_total ? (r.credit_total | currency) : '' }}</td>
								<td class="right amount" [class.neg]="r.applied < 0">{{ r.applied ? (r.applied | currency) : '' }}</td>
								<td class="center">
									<span class="settled" [class.yes]="r.settled==='Yes'" *ngIf="r.settled">{{ r.settled }}</span>
								</td>
								<td class="center nowrap">
								{{ qtyReceivedLabel(r) }}
								<small class="receipt-ref" *ngIf="receiptLabel(r)">{{ receiptLabel(r) }}</small>
							</td>
								<td class="center">
									<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Actions">
										<mat-icon>more_vert</mat-icon>
									</button>
									<mat-menu #menu="matMenu">
										<button mat-menu-item (click)="previewCredit(r, creditPreview)">
											<mat-icon>visibility</mat-icon>
											<span>Preview</span>
										</button>
										<button mat-menu-item (click)="editDetails(r)">
											<mat-icon>edit</mat-icon>
											<span>Edit details</span>
										</button>
										<button mat-menu-item *ngIf="r.rma_state !== 'Cancelled' && r.rma_state !== 'Processed'" (click)="finalizeCredit(r)">
											<mat-icon>description</mat-icon>
											<span>Finalize credit</span>
										</button>
										<button mat-menu-item *ngIf="r.rma_state !== 'Cancelled' && r.rma_state !== 'Processed'" (click)="cancelRma(r)">
											<mat-icon>remove</mat-icon>
											<span>Cancel</span>
										</button>
									</mat-menu>
								</td>
							</tr>
							<!-- What actually has to be reconciled before this RMA can be credited. -->
							<tr class="exception-row" *ngIf="reviewReasons(r).length">
								<td [attr.colspan]="columns.length + 2">
									<span class="exception-label">Needs reconciling before credit:</span>
									<span class="exception-item" *ngFor="let reason of reviewReasons(r)">{{ reason }}</span>
								</td>
							</tr>
							</ng-container>
							<tr *ngIf="!sending && !rmas.length" class="empty-row">
								<td [attr.colspan]="columns.length + 2">No RMAs found for the selected filters.</td>
							</tr>
							<tr *ngIf="sending" class="empty-row">
								<td [attr.colspan]="columns.length + 2">Loading…</td>
							</tr>
						</tbody>
						<tfoot *ngIf="rmas.length">
							<tr>
								<td [attr.colspan]="6" class="right foot-label">Total credit issued</td>
								<td class="right amount" [class.neg]="sumAmount() < 0">{{ sumAmount() | currency }}</td>
								<td colspan="4"></td>
							</tr>
						</tfoot>
					</table>
				</div>

			</div>
		</div>
	</div>
</div>
